import {
  ANSWER_LIST, 
  ANSWER_LIST_SUCCESS, 
  ANSWER_LIST_ERROR,
  ANSWER_SEARCH_SET, 
  ANSWER_SEARCH_CHANGE, 
  ANSWER_PAGE_SET,
  ANSWER_SEARCH_ASSESSMENT_LIST,
  ANSWER_SEARCH_ASSESSMENT_LIST_SUCCESS,
  ANSWER_SEARCH_ASSESSMENT_LIST_ERROR,
  ANSWER_ADD_SET,
  ANSWER_ADD_MODAL_SET,
  ANSWER_ADD,
  ANSWER_ADD_SUCCESS,
  ANSWER_ADD_ERROR,
  ANSWER_ADD_CHANGE,
  ANSWER_DETAIL,
  ANSWER_DETAIL_SUCCESS,
  ANSWER_DETAIL_ERROR,
  ANSWER_VIEW_MODAL_SET,
  ANSWER_EDIT_CHANGE,
  ANSWER_EDIT_MODAL_SET,
  ANSWER_UPDATE,
  ANSWER_UPDATE_SUCCESS,
  ANSWER_UPDATE_ERROR,
  ANSWER_VIEW_TAB_SET,
  ANSWER_UPLOAD_SET,
  ANSWER_UPLOAD_SET_SUCCESS,
  ANSWER_UPLOAD_SET_ERROR,
  ANSWER_UPLOAD_RESET
} from '../../actions';
 
const INIT_STATE = {
  loading: true,
  file: [],
  list: {
    header:{
      name: 'code',
      order:'sorted-asc'
    },
    page:{
      current: 1,
      rows: 10
    }
  },
  add: {
      data: {
        new:{ id_assessment: null, assessment: null, code: '', name: '', description: '', if_answer: false, url_file: '', original_file_name: '', file_name: '' }
      },
      modal: false,
      loading: false,
      message: '',
      url: '',
      type: ''
  },
  error: false,
  search:{
    modal: false,
    init:true,
    data:{
      assessment: false
    },
    value:{
      assessment: false,
    },
    assessment:{
      loading: true,
      list:[],
      message: ''
    }
  },
  detail: {
    data: [],
    tab: 'general',
    loading: true,
  },
  view: {
    loading: true,
    data: [],
    tab: 'general',
    modal: false,
    log: {
      data: [],
      loading: false,
    },
  },
  edit: {
    loading: true,
    data: {
        new: [],
        old: []
    },
    list: {
        status: {
            data: [],
            loading: false,
        }
    },
    modal: false,
    update: {
        loading: false,
        response: '',
        message: ''
    }
  }
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case ANSWER_LIST:
      return {
        ...state,
        loading: true,
        list: {
          ...state.list
        }
        
      }
    case ANSWER_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        list: {
          ...state.list,
          ...action.payload
        } 
      }
    case ANSWER_LIST_ERROR:
      return {
        ...state,
        loading: false,
        error: true
      }
    case ANSWER_SEARCH_SET:
      return {
        ...state,
        search:{
          ...state.search,
          data: action.payload,
        }
      }
    case ANSWER_SEARCH_CHANGE:
      return {
        ...state,
        search:{
          ...state.search,
          value: action.payload,
        }
      }
    case ANSWER_PAGE_SET:
      return {
        ...state,
        list: {
          ...state.list,
          page: {
            ...state.list.page,
            ... action.payload,
          }
        },
        log: []
      }
    case ANSWER_SEARCH_ASSESSMENT_LIST:
      return {
        ...state,
        search:{
          ...state.search,
          init:false,
          assessment:{
            ...state.search.assessment,
            loading: true,
            list:[],
            message: ''
          }
        }
      }
    case ANSWER_SEARCH_ASSESSMENT_LIST_SUCCESS:
      return {
        ...state,
        search:{
          ...state.search,
          assessment:{
            ...state.search.assessment,
            loading: false,
            list: action.payload,
            message: ''
          }
        }
      }
    case ANSWER_SEARCH_ASSESSMENT_LIST_ERROR:
      return {
        ...state,
        search:{
          ...state.search,
          assessment:{
            ...state.search.assessment,
            loading: false,
            list:[],
            message: 'No se encotraron datos'
          }
        }
      }
    case ANSWER_ADD_CHANGE:
      return {
        ...state,
        add: {
          ...state.add,
          data: {
            ...state.add.data,
            new: {
              ...state.add.data.new,
              ...action.payload
            }
          }
        }
      }
    case ANSWER_ADD_SET:
      return {
        ...state,
        add: {
          ...state.add,
          data: action.payload
        }
      }
    case ANSWER_ADD_MODAL_SET:
      return {
        ...state,
        add: {
          ...state.add,
          data: { 
            ...state.add.data,
            new: { id_assessment: null, assessment: null, code: '', name: '', description: '', if_answer: false, url_file: '', original_file_name: '', file_name: ''}
          },
          modal: action.payload
        }
      }
    case ANSWER_ADD:
      return {
        ...state,
        add: {
          ...state.add, 
          loading: true
        }
      }
    case ANSWER_ADD_SUCCESS:
      return {
        ...state,
        add: {
          ...state.add,
          modal: false,
          loading: false,
          message: action.payload.message,
          id: action.payload.id
        }
      }
    case ANSWER_ADD_ERROR:
      return {
        ...state,
        add: {
          ...state.add,
          loading: false,
          message: action.payload.message
        }
      }
    case ANSWER_DETAIL:
      return {
        ...state,
        detail: {
          ...state.detail,
          loading: true,
          data: []
        }
      }
    case ANSWER_DETAIL_SUCCESS:
      return {
        ...state,
        detail: {
          ...state.detail,
          loading: false,
          data: action.payload
        },
        edit: {
          ...state.edit,
          loading: false,
          data: {
            new: action.payload,
            old: action.payload
          }
        }
      }
    case ANSWER_DETAIL_ERROR:
      return {
        ...state,
        detail: {
          ...state.detail,
          loading: false,
          data: []
        }
      }
    case ANSWER_VIEW_MODAL_SET:
      return {
        ...state,
        view: {
          ...state.view,
          modal: action.payload
        }
      }
    case ANSWER_EDIT_MODAL_SET:
      return {
        ...state,
        edit: {
          ...state.edit,
          modal: action.payload
        }
      }
    case ANSWER_EDIT_CHANGE:
      return {
        ...state,
        edit: {
          ...state.edit,
          data: {
            ...state.edit.data,
            new: {
              ...state.edit.data.new,
              ...action.payload
            }
          }
        }
      }
    case ANSWER_UPDATE:
      return {
        ...state,
        edit: {
          ...state.edit,
          data: {
            ...state.edit.data,
            ...action.payload,
          },
          update: {
            ...state.update,
            loading: true,
            response: '',
            message: ''
          }
        }
      }
    case ANSWER_UPDATE_SUCCESS:
      return {
        ...state,
        edit: { 
          ...state.edit,
          modal: false,
          data: {
            ...state.edit.data,
            new: {
              ...state.edit.data.new,
              update_reason: ''
            },
            old: {
              ...state.edit.data.new,
              update_reason: ''
            }
          },
          update: {
            ...state.update,
            loading: false,
            response: 'success',
            message: action.payload
          }
        },
        view: {
          ...state.view,
          modal: false
        }
      }
    case ANSWER_UPDATE_ERROR:
      return {
        ...state,
        edit: {
          ...state.edit,
          update: {
            ...state.update,
            loading: false,
            response: 'error',
            message: action.payload
          }
        }
      }
    case ANSWER_VIEW_TAB_SET:
      return {
        ...state,
        view: {
          ...state.view,
          tab: action.payload
        }
      }
    case ANSWER_UPLOAD_SET:
      return { ...state };
    case ANSWER_UPLOAD_SET_SUCCESS:
      return {
        ...state,
        file: [...state.file, action.payload]
      };
    case ANSWER_UPLOAD_SET_ERROR:
      return { 
        ...state,
        file: [...state.file, action.payload]
      };
    case ANSWER_UPLOAD_RESET:
      return {
        ...state,
        file: []
      };
    default:
      return { ...state };
    }

};